import type { PropTypes } from './LogOutModal.types';
import type { ReactElement } from 'react';

import { Button, Flex, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import { requestLogOutUser } from '../../../state/ProfileSlice';
import { AlertDialog } from '../../Dialog';

import styles from './LogOutModal.module.css';

export function LogOutModal(props: PropTypes): ReactElement {
  const { open, onClose } = props;
  const { t } = useTranslation();
  const logOut = useAppSelector((state) => state.profile.logOut);
  const isDarkMode = useAppSelector((state) => state.settings.isDarkMode);
  const logOutImage = isDarkMode
    ? '/imgs/illustrations/logout-modal-dark.svg'
    : '/imgs/illustrations/logout-modal-light.svg';
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogOut = async () => {
    await dispatch(requestLogOutUser());
    if (location.pathname.includes('profile')) {
      navigate('/profile', { replace: true });
    }
    onClose();
  };

  return (
    <AlertDialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onClose();
        }
      }}
      width="small"
      title={t('Log out of your profile?')}
      footer={
        <>
          <Button
            id="profile-page-sign-out-modal-no-btn"
            variant="ghost"
            color="gray"
            size="3"
            radius="full"
            disabled={logOut.loading}
            className={styles.cancelButton}
            onClick={onClose}>
            {t('Cancel')}
          </Button>
          <Button
            id="profile-page-sign-out-modal-yes-btn"
            variant="solid"
            color="red"
            size="3"
            radius="full"
            loading={logOut.loading}
            disabled={logOut.loading}
            onClick={handleLogOut}>
            {t('Log out')}
          </Button>
        </>
      }>
      <Flex direction="column" gap="5" align="center">
        <img src={logOutImage} alt={t('Log out of your profile?')} className={styles.image} />
        <Text size="2" color="gray" align="center">
          {t(
            "You'll be signed out of your profile, but your wallet will stay connected so you can keep swapping. Sign in again anytime to access your profile.",
          )}
        </Text>
      </Flex>
    </AlertDialog>
  );
}
